import Table from "../../components/Table";
import { store } from "store/store";
import { apiGetTaxFactors, apiMoaddianInquiry, checkRimaToken } from "api/moaddian";
import ContainedTabs from "components/Tabs/Tabs3";
import { useState } from "react";
import BasicButton from "components/BasicInputs/BasicButton";
export default function TaxSystem() {
  const [active, setActive] = useState(0)
  const [activeTab, setActiveTab] = useState("Pending")


  const taxMidComponent = () => {
    const { getState, dispatch } = store

    const getAllapiMoaddian = async () => {
      checkRimaToken(async (res: boolean) => {
        if (res) {
          const rows = getState().dataTableReducer.items
          const factorIds = []
          for (const row of rows) {
            factorIds.push(row.id)
          }
          dispatch(apiMoaddianInquiry(factorIds))

        }
      })



    }
    return <div className="flex gap-5">
      <ContainedTabs
        tabs={[
          { label: "ارسال شده", activeColor: "#1062D0" },
          { label: "ارسال نشده", activeColor: "#1062D0" },
        ]}
        activeTab={active}
        centered={true}
        onChange={(val) => {
          // dispatch(apiGetTaxFactors({ key: val ? "NotSent" : "Pending" }))
          val !== undefined && setActive(val)
        }}
        size={1}
        minWidth={100}
      />
      {activeTab === "Pending" ? <BasicButton variant="outlined" onClick={() => {
        getAllapiMoaddian()
      }}>
        <span>استعلام تمامی صورت حساب ها</span>
      </BasicButton> : null}
    </div>
  }
  const dispatch = store.dispatch
  if (active === 1) {
    return <Table type="taxNotSent" MidComponent={taxMidComponent} />;
  }
  return <Table type="tax" onTabChange={(op) => {
    setActiveTab(op.activeTab.apiKey)
    dispatch(apiGetTaxFactors({ key: op.activeTab.apiKey }))
  }} MidComponent={taxMidComponent} />;
}
